import React, {useState} from "react";
import "./Banner.css";
import telegram from "./assets/brand-telegram.svg";
import twitter from "./assets/twitterLogo.svg";
import youtube from "./assets/youtubeLogo.svg";
import bannerImg from "./assets/banner.png";
import LoginModal from "../../../GlobalComponents/LoginModal/LoginModal";
import Popup from "reactjs-popup";

import img1 from "./assets/image1.png";
import img2 from "./assets/image2.png";
import img3 from "./assets/image3.png";
import img4 from "./assets/image4.png";
import { connectAcc } from "./interface";
import { useConnectModal, useAccountModal, useChainModal } from "@rainbow-me/rainbowkit";
import { useBalance, useAccount, useFeeData } from "wagmi";
const Banner = ({parentRef}) => {
  const [openBid, setOpenBid] = useState(false);
  const { openConnectModal } = useConnectModal();
  const handleDAO = () =>{
    window.location.href="/nft-auction";
  }
  var { address } = useAccount();
  const handleDapp = async() =>{
    if(address)
      setOpenBid(true);
    else{
      await connectAcc(openConnectModal);
    }
  }
  return (
    <div className="mt-[70px] md:mt-[136px]">
      <div className="container ">
        <div className="max-w-[1152px] mx-auto ">
          <div className="flex flex-col items-center lg:flex-row  gap-[30px] md:gap-[100px]">
            <div className="max-w-[590px] w-full">
              <h1 className="text-res-lg font-black mb-[10px]">
                Shape the Future of Decentralized Organizations
              </h1>

              <p className="text-res-ls mb-[20px] font-semibold">
                Become a part of a community-driven movement that is changing
                the way we think about decentralized organizations and
                governance.
              </p>
              <div className="flex flex-col sm:flex-row gap-[18px]">
                <button onClick={handleDAO} className="bg-custom-gradient  w-[173px] h-10 rounded-[20px] text-res-light-black font-bold text-[#0E0E0E]">
                  Join DAO
                </button>

                <div className="border rounded-[20px] border-solid px-[20px] pt-[10px] pb-[11px] border-main-white text-main-white w-[173px] h-[40px]">
                  <button onClick={handleDapp} id="DAO" className="text-center w-full h-full flex justify-center items-center">
                    <span className="text-res-xs font-bold">Go to DAPP</span>
                  </button>
                </div>

                <div className="border rounded-[20px] border-solid px-[20px] pt-[10px] pb-[11px] border-white w-[271px] h-[40px] flex align-center">
                  <div className="flex gap-x-[25px] items-center">
                    <h4 className="text-res-xs font-bold">Our Socials</h4>
                    <a target="_blank" href="#">
                      <img src={telegram} alt="" />
                    </a>
                    <a href="#" target="_blank">
                      <img src={twitter} alt="" />
                    </a>
                    <a href="#" target="_blank">
                      <img src={youtube} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-grow">
              {/* <img src={bannerImg} alt="" /> */}
              <div className="w-full md:w-[480px]">
                <iframe
                  height="315"
                  width="100%"
                  src="https://www.youtube.com/embed/xcJtL7QggTI"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-main-black mt-[100px] md:mt-[200px]">
        <div className="container">
          <div className="grid max-w-[400px] lg:max-w-[878px] mx-auto grid-cols-2 lg:grid-cols-4 gap-[40px] lg:gap-[103px]  min-h-[80px] items-center justify-center pt-[23px] pb-[22px]">
            <img src={img1} alt="logo" />

            <img src={img4} alt="logo" />

            <img src={img3} alt="logo" />

            <img src={img2} alt="logo" />
          </div>
        </div>
      </div>
      <>
        <Popup open={openBid} position="right center">
          <div className="modalOverlay"></div>
          <LoginModal
            open={openBid}
            setOpen={setOpenBid}
          ></LoginModal>
        </Popup>
      </>
    </div>
  );
};

export default Banner;
